import React, { useEffect, useState } from "react";
import axios from "axios";
// import PayslipModal from "../components/modal/PaySlip";
import PayslipModal from "../components/modal/EmployeePaySlip";
import PaginatedTable from "../components/library/Pagination";
import Loader from "../components/common/Loader";
import API_BASE_URL from "../config/api";

const PayrollPage = () => {
    const [summary, setSummary] = useState({});
    const [payrollData, setPayrollData] = useState([]);
    const [filteredPayrollData, setFilteredPayrollData] = useState([]);
    const [year, setYear] = useState("");
    const [month, setMonth] = useState("");
    const [search, setSearch] = useState("");
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [yearList, setYearList] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [notification, setNotification] = useState(null);
    const [loading, setLoading] = useState(false);

    const token = sessionStorage.getItem("token"); // assumed
    const employeeId = sessionStorage.getItem("username");

    const fetchOption = async () => {
        try {
            const res = await axios.get(`${API_BASE_URL}/api/Config/children/12`);

            const minYearStr = Array.isArray(res.data) && res.data.length > 0 ? res.data[0].value : null;
            const minYear = parseInt(minYearStr, 10);
            const currentYear = new Date().getFullYear();
            if (!isNaN(minYear)) {
                const years = [];
                for (let y = currentYear; y >= minYear; y--) {
                    years.push(y.toString());
                }
                setYearList(years);
            } else {
                setYearList([]);
            }
        } catch (error) {
            console.error("Error fetching year list:", error);
            setYearList([]);
        }
    };


    const fetchPayroll = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${API_BASE_URL}/api/payroll/payrolldata?year=${year}&month=${month}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setPayrollData(response.data.payrolls);
            setFilteredPayrollData(response.data.payrolls);
            setSummary(response.data.summary);
            handleSelectAll(false);
        } catch (err) {
            console.error("Failed to fetch payroll:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOption();
    }, []);

    const handleCloseNotification = () => setNotification(null);

    const generatePayroll = async () => {
        if (!year || !month) {
            setNotification({
                type: "error",
                message: "Please select both Year and Month.",
            });
            return;
        }

        try {
            setLoading(true);
            handleCloseNotification();
            const token = sessionStorage.getItem("token");
            const response = await fetch(
                `${API_BASE_URL}/api/Payroll/generate`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        year: year,
                        monthName: month,
                        createdBy: employeeId,
                    }),
                }
            );

            if (response.ok) {
                setNotification({
                    type: "success",
                    message: "Payroll generated successfully.",
                });
                fetchPayroll();
                handleSelectAll(false);
            } else {
                const error = await response.json();
                setNotification({
                    type: "error",
                    message: error?.message || "Failed to generate payroll.",
                });
            }
        } catch (err) {
            setNotification({
                type: "error",
                message: "Error occurred while generating payroll.",
            });
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const openPayslip = (employee) => {
        setSelectedEmployee(employee);
        setIsModalOpen(true);
    };

    const closePayslip = () => {
        setIsModalOpen(false);
        setSelectedEmployee(null);
    };

    // Toggle checkbox
    const handleCheckboxChange = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    // Select all
    const handleSelectAll = (checked) => {
        if (checked) {
            setSelectedIds(payrollData.map((item) => item.id));
        } else {
            setSelectedIds([]);
        }
    };

    const changeStatus = async () => {
        if (selectedIds.length === 0) {
            setNotification({
                type: "error",
                message: "Please select at least one payslip to update.",
            });
            return;
        }

        try {
            setLoading(true);
            handleCloseNotification();
            const token = sessionStorage.getItem("token");

            // loop through each ID and update
            for (const id of selectedIds) {
                const response = await fetch(
                    `${API_BASE_URL}/api/Payroll/update-status/${id}?status=Paid`,
                    {
                        method: "PUT",
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (!response.ok) {
                    const error = await response.json();
                    setNotification({
                        type: "error",
                        message: error?.message || `Failed to update payroll ${id}`,
                    });
                    return;
                }
            }

            setNotification({
                type: "success",
                message: "Selected payrolls marked as Paid.",
            });
            fetchPayroll();
        } catch (err) {
            setNotification({
                type: "error",
                message: "Error occurred while updating payrolls.",
            });
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        let result = [...payrollData];

        if (search.trim() !== "") {
            const text = search.toLowerCase();
            result = result.filter(
                (item) =>
                    item.fullName?.toLowerCase().includes(text) ||
                    item.employeeCode?.toLowerCase().includes(text)
            );
        }

        setFilteredPayrollData(result);
    }, [search, payrollData]);




    return (
        <>
            {loading ? (
                <Loader message="Loading..." />
            ) : (
                <div className="relative flex min-h-screen flex-col bg-white group/design-root overflow-x-hidden">
                    <div className="layout-container flex h-full grow flex-col">
                        <div className="flex flex-1 justify-center py-5">
                            <div className="layout-content-container flex flex-col flex-1">
                                <div className="mb-6">
                                    <h1 className="text-3xl font-bold text-[#121516]">Payroll</h1>
                                </div>

                                {notification && (
                                    <div
                                        className={`mb-4 px-4 py-3 rounded flex justify-between items-start ${notification.type === "error"
                                            ? "bg-red-100 text-red-700"
                                            : "bg-green-100 text-green-700"
                                            }`}
                                    >
                                        <span>{notification.message}</span>
                                        <button
                                            onClick={handleCloseNotification}
                                            className="ml-4 font-bold text-lg leading-none"
                                        >
                                            ×
                                        </button>
                                    </div>
                                )}

                                {/* Filters */}
                                <div className="flex gap-4 mb-4 flex-wrap items-end">

                                    <div>
                                        <label className="block text-sm font-medium mb-2">Year</label>
                                        <select
                                            className="w-60 h-12 border rounded-xl p-2"
                                            value={year}
                                            onChange={(e) => setYear(e.target.value)}
                                        >
                                            <option value="">Select Year</option>
                                            {Array.isArray(yearList) &&
                                                yearList.map((y) => (
                                                    <option key={y} value={y}>
                                                        {y}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium mb-2">Month</label>
                                        <select
                                            className="w-60 h-12 border rounded-xl p-2"
                                            value={month}
                                            onChange={(e) => setMonth(e.target.value)}
                                        >
                                            <option value="">Select Month</option>
                                            {Array.from({ length: 12 }, (_, i) => {
                                                const monthName = new Date(0, i).toLocaleString("default", { month: "long" });
                                                return (
                                                    <option key={monthName} value={monthName}>
                                                        {monthName}
                                                    </option>
                                                );
                                            })}
                                        </select>

                                    </div>
                                    <button
                                        onClick={fetchPayroll}
                                        className="custom-btn mb-2"
                                    >
                                        Apply Filter
                                    </button>
                                    <button
                                        onClick={generatePayroll}
                                        className="custom-btn mb-2"
                                    >
                                        Generate Payroll
                                    </button>
                                    <button
                                        className="btn-black mb-2"
                                        onClick={changeStatus}
                                    >
                                        Mark As Paid
                                    </button>
                                </div>

                                {/* Summary Cards */}
                                <h2 className="text-xl font-bold mb-2">Payroll Summary</h2>
                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
                                    <div className="border rounded-xl p-4">
                                        <p className="text-base font-medium">Total Salary Disbursed</p>
                                        {/* <p className="text-2xl font-bold">₹{summary.totalPaid || 0}</p> */}
                                        <p className="text-2xl font-bold">
                                            ₹{summary.totalPaid ? summary.totalPaid.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
                                        </p>
                                    </div>
                                    <div className="border rounded-xl p-4">
                                        <p className="text-base font-medium">Average Salary</p>
                                        {/* <p className="text-2xl font-bold">₹{summary.averageSalary || 0}</p> */}
                                        <p className="text-2xl font-bold">
                                            ₹{summary.averageSalary ? summary.averageSalary.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
                                        </p>
                                    </div>
                                    <div className="border rounded-xl p-4">
                                        <p className="text-base font-medium">Total Deductions</p>
                                        {/* <p className="text-2xl font-bold">₹{summary.totalDeductions || 0}</p> */}
                                        <p className="text-2xl font-bold">
                                            ₹{summary.totalDeductions ? summary.totalDeductions.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}
                                        </p>
                                    </div>
                                </div>

                                <div className="flex justify-end w-full px-4">
                                    <div className="relative max-w-[250px] w-full">
                                        {/* Search Icon */}
                                        <span className="absolute inset-y-0 left-3 flex items-center text-gray-400 pointer-events-none">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-5 w-5"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M21 21l-4.35-4.35M17 10a7 7 0 11-14 0 7 7 0 0114 0z"
                                                />
                                            </svg>
                                        </span>

                                        {/* Input */}
                                        <input
                                            type="text"
                                            placeholder="Search by name"
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                            className="rounded-md border h-14 pl-12 pr-3 w-full focus:ring-2 focus:ring-blue-400 outline-none"
                                        />
                                    </div>
                                </div>


                                {/* Payroll Table */}
                                <div className="overflow-auto border rounded-xl mt-6">

                                    <PaginatedTable
                                        columns={[
                                            <input
                                                type="checkbox"
                                                checked={selectedIds.length === payrollData.length && payrollData.length > 0}
                                                onChange={(e) => handleSelectAll(e.target.checked)}
                                            />,
                                            "Employee Code",
                                            "Employee",
                                            "BasicPay",
                                            "Allowances",
                                            "Deductions",
                                            "Net Salary",
                                            "Status",
                                            "Payslip",
                                        ]}
                                        data={filteredPayrollData}
                                        pageSize={10}
                                        renderRow={(item) => (
                                            <tr key={item.employeeId} className="border-t">
                                                <td className="px-4 py-3">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedIds.includes(item.id)}
                                                        onChange={() => handleCheckboxChange(item.id)}
                                                    />
                                                </td>
                                                <td className="px-4 py-3">{item.employeeCode}</td>
                                                <td className="px-4 py-3">{item.fullName}</td>
                                                <td className="px-4 py-3">₹{Number(item.basicPay || 0).toLocaleString("en-US")}</td>
                                                <td className="px-4 py-3">₹{Number(item.allowances || 0).toLocaleString("en-US")}</td>
                                                <td className="px-4 py-3">₹{Number(item.deductions || 0).toLocaleString("en-US")}</td>
                                                <td className="px-4 py-3">₹{Number(item.netSalary || 0).toLocaleString("en-US")}</td>
                                                <td className="px-4 py-3">
                                                    <span
                                                        className={`px-3 py-1 rounded-full text-sm 
                                                ${item.status === "Paid" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}`}
                                                    >
                                                        {item.status}
                                                    </span>
                                                </td>
                                                <td className="px-4 py-3">
                                                    <button
                                                        className="flex min-w-[80px] max-w-[80px] cursor-pointer items-center justify-center hover:bg-black hover:text-white overflow-hidden rounded-full h-8 px-4 bg-[#f1f3f4] text-[#121516] text-sm font-medium leading-normal w-full"
                                                        onClick={() => openPayslip(item)}
                                                    >
                                                        View
                                                    </button>
                                                </td>
                                            </tr>
                                        )}
                                    />

                                </div>
                                {isModalOpen && selectedEmployee && (
                                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                                        <div className="bg-white rounded-xl max-w-3xl w-full max-h-[90vh] overflow-auto relative">
                                            <button
                                                className="absolute top-2 right-4 text-gray-500 hover:text-gray-800"
                                                onClick={closePayslip}
                                            >
                                                ✕
                                            </button>
                                            <PayslipModal
                                                employeeId={selectedEmployee.employeeId}
                                                id={selectedEmployee.id}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PayrollPage;
